export const mobileCategory = [
  {
    categoryId: 0,
    categoryName: "Driver Portal",
    categoryKey: "Permissions.MobilePermissions.DriverPortal",
    subcategories: [
      {
        subcategoryId: 0,
        subcategoryName: "Driver Portal",
        categoryKey: "Permissions.MobilePermissions.DriverPortal",
        items: [
          {
            id: 1,
            title: "Driver Portal",
            categoryKey: "Permissions.MobilePermissions.DriverPortal.DriverPortal",
            categoryKey2: "Permissions.Mobiles.JobBookings.DriverPortal.ListView",
            thumbnails: [
              {
                title: "Thumbnail 7",
                url: "https://via.placeholder.com/150",
                videoUrl:
                  "https://productionagaas.blob.core.windows.net/a1gaas-prod-drill1/93659078-b959-421a-9184-9a26485e363b/JobBookingTutorial/Finance/Car Look Up/ae512280-b840-45a6-999e-34fe200544a5.mp4",
              },
              {
                title: "Thumbnail 8",
                url: "https://www.veeforu.com/wp-content/uploads/2022/10/red-gaming-thumbnail-download.jpg",
                videoUrl:
                  "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    categoryId: 1,
    categoryName: "Customer Portal",
    categoryKey: "Permissions.MobilePermissions.CustomerPortal",
    subcategories: [
      {
        subcategoryId: 1,
        subcategoryName: "Create Job",
        categoryKey: "Permissions.MobilePermissions.CustomerPortal",
        items: [
          {
            id: 3,
            title: "Customer Portal",
            categoryKey: "Permissions.MobilePermissions.CustomerPortal.CustomerJobList",
            categoryKey2: "Permissions.Mobiles.JobBookings.CustomerPortal.ListView",
            thumbnails: [
              {
                title: "Thumbnail 3",
                url: "https://i.pinimg.com/736x/ed/93/6f/ed936fa3053731b50c0af7a8018453ee.jpg",
              },
              {
                title: "Thumbnail 4",
                url: "https://via.placeholder.com/150",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    categoryId: 2,
    categoryName: "Dismantler Portal",
    categoryKey: "Permissions.MobilePermissions.DismantlerPortal",
    subcategories: [
      {
        subcategoryId: 2,
        subcategoryName: "Dismantler Portal",
        categoryKey: "Permissions.MobilePermissions.DismantlerPortal",
        items: [
          {
            id: 5,
            title: "Dismantler Portal",
            categoryKey: "Permissions.MobilePermissions.DismantlerPortal.DismantlerPortal",
            categoryKey2: "Permissions.Mobiles.Inventories.DismantlerPortal.ListView",
            thumbnails: [
              {
                title: "Thumbnail 7",
                url: "https://via.placeholder.com/150",
              },
              {
                title: "Thumbnail 8",
                url: "https://via.placeholder.com/150",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    categoryId: 3,
    categoryName: "Container Packer Portal",
    categoryKey: "Permissions.MobilePermissions.ContainerPackerPortal",
    subcategories: [
      {
        subcategoryId: 3,
        subcategoryName: "Container Packer Portal",
        categoryKey: "Permissions.MobilePermissions.ContainerPackerPortal",
        items: [
          {
            id: 6,
            title: "Container Packer Portal",
            categoryKey: "Permissions.MobilePermissions.ContainerPackerPortal.ContainerPackerPortal",
            categoryKey2: "Permissions.Mobiles.Inventories.ContainerPackerPortal.ListView",
            thumbnails: [
              {
                title: "Thumbnail 7",
                url: "https://via.placeholder.com/150",
              },
              {
                title: "Thumbnail 8",
                url: "https://via.placeholder.com/150",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    categoryId: 4,
    categoryName: "Scrap Car Body Portal",
    categoryKey: "Permissions.MobilePermissions.ScrapCarBodyPortal",
    subcategories: [
      {
        subcategoryId: 4,
        subcategoryName: "Scrap Car Body Portal",
        categoryKey: "Permissions.MobilePermissions.ScrapCarBodyPortal",
        items: [
          {
            id: 7,
            title: "Scrap Car Body Portal",
            categoryKey: "Permissions.MobilePermissions.ScrapCarBodyPortal.ScrapCarBodyPortal",
            categoryKey2: "Permissions.Mobiles.Inventories.ScrapMetalPortal.ListView",
            thumbnails: [
              {
                title: "Thumbnail 7",
                url: "https://via.placeholder.com/150",
              },
              {
                title: "Thumbnail 8",
                url: "https://via.placeholder.com/150",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    categoryId: 5,
    categoryName: "Overseas Agent Portal",
    categoryKey: "Permissions.MobilePermissions.OverseasAgentPortal",
    subcategories: [
      {
        subcategoryId: 4,
        subcategoryName: "Overseas Agent Portal",
        categoryKey: "Permissions.MobilePermissions.OverseasAgentPortal",
        items: [
          {
            id: 17,
            title: "Container",
            categoryKey: "Permissions.MobilePermissions.OverseasAgentPortal.Container",
            categoryKey2: "Permissions.Mobiles.OffshoreInventories.OffshoreShippingContainer.ListView",
            thumbnails: [
              {
                title: "Thumbnail 7",
                url: "https://via.placeholder.com/150",
              },
              {
                title: "Thumbnail 8",
                url: "https://via.placeholder.com/150",
              },
            ],
          },
          {
            id: 18,
            title: "Stock Inventory",
            categoryKey: "Permissions.MobilePermissions.OverseasAgentPortal.StockInventory",
            categoryKey2: "Permissions.Mobiles.OffshoreInventories.OffshoreSell.ListView",
            thumbnails: [
              {
                title: "Thumbnail 7",
                url: "https://via.placeholder.com/150",
              },
            ],
          },
          // {
          //   id: 19,
          //   title: "Sales",
          //   categoryKey: "Permissions.MobilePermissions.OverseasAgentPortal.Sales",
          //   categoryKey2: "Permissions.Mobiles.OffshoreInventories.OffshoreSell.ListView",
          //   thumbnails: [
          //     {
          //       title: "Thumbnail 7",
          //       url: "https://via.placeholder.com/150",
          //     },
          //   ],
          // },
        ],
      },
    ],
  },
  {
    categoryId: 6,
    categoryName: "Yard Manager Portal",
    categoryKey: "Permissions.MobilePermissions.YardManagerPortal",
    subcategories: [
      {
        subcategoryId: 6,
        subcategoryName: "Yard Manager Portal",
        categoryKey: "Permissions.MobilePermissions.YardManagerPortal",
        items: [
          {
            id: 24,
            title: "CAT Inventory",
            categoryKey: "Permissions.MobilePermissions.YardManagerPortal.CATInventory",
            categoryKey2: "Permissions.Mobiles.YardManagerPortals.CatalystConverterManager.ListView",
            thumbnails: [
              {
                title: "Thumbnail 7",
                url: "https://via.placeholder.com/150",
              },
              {
                title: "Thumbnail 8",
                url: "https://via.placeholder.com/150",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    categoryId: 7,
    categoryName: "Report",
    categoryKey: "Permissions.MobilePermissions.Reports",
    subcategories: [
      {
        subcategoryId: 7,
        subcategoryName: "Report",
        categoryKey: "Permissions.MobilePermissions.Reports",
        items: [
          {
            id: 30,
            title: "Overview",
            categoryKey: "Permissions.MobilePermissions.Reports.Overview",
            categoryKey2: "Permissions.Mobiles.YardManagerPortals.Report.ListView",
            thumbnails: [
              {
                title: "Thumbnail 7",
                url: "https://via.placeholder.com/150",
              },
              {
                title: "Thumbnail 8",
                url: "https://via.placeholder.com/150",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    categoryId: 8,
    categoryName: "Fix And Resell",
    categoryKey: "Permissions.MobilePermissions.FixAndResell",
    subcategories: [
      {
        subcategoryId: 8,
        subcategoryName: "Fix And Resell",
        categoryKey: "Permissions.MobilePermissions.FixAndResell",
        items: [
          {
            id: 35,
            title: "Sell Driving Car",
            categoryKey: "Permissions.MobilePermissions.FixAndResell.SellDrivingCar",
            categoryKey2: "Permissions.Mobiles.FixAndResells.SellDrivingCar.ListView",
            thumbnails: [
              {
                title: "Thumbnail 7",
                url: "https://via.placeholder.com/150",
              },
            ],
          },
          {
            id: 36,
            title: "Sell Damaged Car",
            categoryKey: "Permissions.MobilePermissions.FixAndResell.SellDamagedCar",
            categoryKey2: "Permissions.Mobiles.FixAndResells.SellDamagedCar.ListView",
            thumbnails: [
              {
                title: "Thumbnail 7",
                url: "https://via.placeholder.com/150",
              },
            ],
          },
          {
            id: 37,
            title: "Sold Cars",
            categoryKey: "Permissions.MobilePermissions.FixAndResell.SoldCars",
            categoryKey2: "Permissions.Mobiles.FixAndResells.SoldCars.ListView",
            thumbnails: [
              {
                title: "Thumbnail 7",
                url: "https://via.placeholder.com/150",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    categoryId: 9,
    categoryName: "Vehicle Inspection",
    categoryKey: "Permissions.MobilePermissions.VehicleInspection",
    subcategories: [
      {
        subcategoryId: 9,
        subcategoryName: "Vehicle Inspection",
        categoryKey: "Permissions.MobilePermissions.VehicleInspection",
        items: [
          {
            id: 38,
            title: "Vehicle Inspection",
            categoryKey: "Permissions.MobilePermissions.VehicleInspection.VehicleInspection",
            categoryKey2: "Permissions.Mobiles.FixAndResells.InspectionReport.ListView",
            thumbnails: [
              {
                title: "Thumbnail 7",
                url: "https://via.placeholder.com/150",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    categoryId: 10,
    categoryName: "User Profile",
    categoryKey: "Permissions.MobilePermissions.UserProfile",
    subcategories: [
      {
        subcategoryId: 10,
        subcategoryName: "User Profile",
        categoryKey: "Permissions.MobilePermissions.UserProfile",
        items: [
          {
            id: 39,
            title: "User Profile",
            categoryKey: "Permissions.MobilePermissions.UserProfile.UserProfile",
            categoryKey2: "Permissions.Mobiles.UserProfile.ListView",
            thumbnails: [
              {
                title: "Thumbnail 7",
                url: "https://via.placeholder.com/150",
              },
            ],
          },
        ],
      },
    ],
  },
];